import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaSolicitudesCompras from "./tablaSolicitudesAprobar";

export const AprobarSolicitudesdCompras = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [activo, setActivo] = useState(true);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [valida, setValida] = useState([]);
  const [depart, setDepart] = useState(null);
  const [tip, setTip] = useState(null);
  const [ticomp, setTicomp] = useState(null);
  const [ubi, setUbi] = useState(null);
  const [pucc, setPucc] = useState(0);
  const [tituloapro, setTituloapro] = useState("");
  const [data, setData] = useState([]);
  const [body, setBody] = useState(null);
  const [codigo, setCodigo] = useState(0);
  const [numtrasla, setNumTrasla] = useState(0);
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtFecha = useRef();
  const txtFechaAprobacion = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtCodigo = useRef();

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (valida === 0) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar las Solicitudes",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      let datos = [];
      let datost = [];
      let validad = [];

      if (operacion === 1) {
        datos.push({
          nid: 0,
          fec: txtFecha.current.value,
          obser: txtObservacion.current.value.trim(),
          tip: parseInt(ticomp),
          depart: parseInt(depart),
          idefi: idefiscal,
          devol: tip,
          aprob: true,
        });

        for (let e = 0; e < data.length; e++) {
          datost.push({
            nid: data[e].idaprobacionesdetalle,
            motiv: "",
            idorden: data[e].idordenpago,
            conce: data[e].concepto,
            idapro: 0,
            tip: parseInt(data[e].tipo),
          });
        }

        for (let i = 0; i < data.length; i++) {
          validad.push({
            idordencs: data[i].idordenpago,
            idefis: idefiscal,
            val: data[i].val,
          });
        }
      }

      setBody({
        operacion: operacion,
        aprobaciones: datos,
        aprobdetalles: datost,
        spiritu: espiritu,
        valida: validad,
        tipoc: tip,
      });
      console.log(datos);

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Aprobar estos Documentos?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/crearaprobacionessolicitudescompras`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Solicitud Aprobada Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setActivate(false);
    setChek(0);
    setValida([]);
    setDepart(null);
    setTip(null);
    setUbi(null);
    setPucc(0);
    setData([]);
    setTicomp(null);
    setBody(null);
    setCodigo(0);
    setTituloapro("");
    setActivo(true);
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const BaseDatos = (data) => {
    if (data.length > 0) {
      setActivo(false);
      setValida(1);
    } else {
      setActivo(true);
      setValida(0);
    }
    setData(data);
    console.log(data);
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          setValues(props.aprobaciones);
          setDatospre(props.aprodetalle);

          if (props.aprobado === true) {
            if (espiritu === 8) {
              setTituloapro(
                <p className="text-success text-center">
                  ¡ El Documento ya fué Enviado a la Direccion de Presupuesto !
                </p>,
              );
            } else {
              setTituloapro(
                <p className="text-success text-center">
                  ¡ El Documento ya fué Enviado a la Direccion de Presupuesto !
                </p>,
              );
            }
          } else if (props.aprobado === false) {
            setTituloapro(
              <p className="text-warning text-center">
                ¡ El Documento esta por Enviar a la Direccion de Presupuesto !
              </p>,
            );
          }
        } else {
          txtObservacion.current.value = "";
          txtFecha.current.value = moment
            .utc(fechaSistema)
            .format("YYYY-MM-DD");
          txtCodigo.current.value = "";

          if (
            props.titulo === "Aprobación de Solicitudes de Compras/Servicios"
          ) {
            if (espiritu === 8) {
              setDepart(2);
            } else {
              setDepart(9);
            }

            if (espiritu === 7) {
              setUbi(50);
              setTip(1);
              setTicomp(0);
            } else {
              setUbi(38);
              setTip(1);
              setTicomp(2);
            }
          }
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? props.titulo
              : operacion === 2
                ? props.titulo
                : operacion === 3
                  ? props.titulo
                  : props.titulo}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <div>
          <input type="hidden" ref={txtNp} />

          <fieldset className="row border-azul rounded mx-auto container mb-2">
            <legend className="float-none m-0 w-auto text-uppercase" style={{
              fontSize: '0.9rem'
            }}>Datos</legend>

            <div className="col-sm-2 mb-1 px-0">
              <div className="input-group input-group-sm m-0 w-100">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Código:
                </label>
                <input
                  type="text"
                  className="form-control text-uppercase"
                  name="observacion"
                  disabled={true}
                  ref={txtCodigo}
                  defaultValue={
                    props.aprobaciones
                      ? props.aprobaciones.idaprobaciones.trim()
                      : ""
                  }
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputDireccion"
                />
              </div>
            </div>

            <div className="col-sm-8 mb-1 px-1">
              <h3> {tituloapro} </h3>
            </div>

            <div className="col-sm-2 mb-1 px-0 ml-auto">
              <div className="input-group input-group-sm m-0 w-100">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Fecha:
                </label>
                <input
                  type="date"
                  className="form-control text-uppercase"
                  disabled={
                    operacion === 4 || operacion === 2 ? true : deshabilitado
                  }
                  ref={txtFecha}
                  defaultValue={
                    props.aprobaciones && props.aprobaciones.fecha !== ""
                      ? moment
                        .utc(props.aprobaciones.fecha)
                        .format("YYYY-MM-DD")
                      : moment.utc(fechaSistema).format("YYYY-MM-DD")
                  }
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputDireccion"
                />
              </div>
            </div>

            <div className="col-sm-12 mb-1 px-0">
              <div className="input-group input-group-sm m-0 w-100">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Observación:
                </label>
                <textarea
                  style={{ height: 50 }}
                  type="text"
                  className="form-control text-uppercase"
                  name="observacion"
                  onChange={onChange}
                  disabled={
                    operacion === 4 || operacion === 2 ? true : deshabilitado
                  }
                  ref={txtObservacion}
                  defaultValue={
                    props.aprobaciones
                      ? props.aprobaciones.observaciones.trim()
                      : ""
                  }
                  placeholder="Descripción de la Observación"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputDireccion"
                />
              </div>
            </div>
          </fieldset>

          <div className="col-md-12 py-1"></div>

          <fieldset className="row border-azul rounded mx-auto">
            <legend className="float-none m-0 w-auto text-uppercase" style={{
              fontSize: '0.9rem'
            }}>
              Detalles de la Solicitud
            </legend>

            <div className="col-md-12 px-0">
              <TablaSolicitudesCompras
                data={BaseDatos}
                datarecords={datospre}
                operacion={operacion}
              />
            </div>
          </fieldset>

          <div className="col-md-12 py-1"></div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {operacion === 2 ? (
          <button
            type="button"
            ref={btnAcepta}
            /* onClick={onChangeValidar} */ className="btn btn-primary btn-sm rounded-pill fw-bold"
          >
            <i className="fas fa-print"></i> Imprimir
          </button>
        ) : (
          <button
            type="button"
            ref={btnAcepta}
            onClick={onChangeValidar}
            disabled={activo}
            className="btn btn-success btn-sm rounded-pill fw-bold"
          >
            <i className="far fa-check-circle"></i> Aceptar
          </button>
        )}

        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill fw-bold"
        >
          <i className="fas fa-window-close"></i> Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
